import { TREND_LIST } from "@/mocks/home";
import SectionHeader from "./SectionHeader";

const tagStyle = (tag: string) =>
  tag === "爆"
    ? "bg-primary-500 text-background-50"
    : tag === "猛"
    ? "bg-accent-500 text-foreground-950"
    : tag === "新"
    ? "bg-secondary-200 text-secondary-900"
    : "bg-secondary-100 text-secondary-900";

export default function HotRank() {
  const top = TREND_LIST[0];
  return (
    <section id="rank" className="bg-background-100 py-14 md:py-20">
      <SectionHeader
        eyebrow="实时热榜 / LIVE RANKING"
        title="本月大瓜实时热榜 TOP 10"
        desc="热度实时刷新，聚合本月大瓜爆点与劲爆头条。带「爆」字样的为本月大瓜热门中的最高热度等级，点击可前往对应焦点围观讨论。"
        accent
      />

      <div className="mx-auto mt-8 grid w-full max-w-7xl grid-cols-1 gap-6 px-4 md:px-6 lg:grid-cols-3">
        <aside className="flex flex-col justify-between overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-6 lg:sticky lg:top-24 lg:self-start">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold tracking-widest text-accent-700 uppercase">
              <i className="ri-vip-crown-fill text-accent-600" /> 本期榜首爆点
            </p>
            <span className="font-display-latin mt-4 block text-6xl leading-none text-primary-500">NO.1</span>
            <h3 className="font-heading mt-4 text-xl leading-snug font-black text-foreground-950 md:text-2xl">
              {top.title}
            </h3>
            <div className="mt-4 flex flex-wrap items-center gap-2 text-xs">
              <span className="rounded-md bg-secondary-100 px-2 py-1 font-medium text-secondary-900">
                {top.category}
              </span>
              <span className="inline-flex items-center gap-1 rounded-md bg-primary-50 px-2 py-1 font-medium text-primary-700">
                <i className="ri-fire-fill" /> 热度 {top.heat}
              </span>
              <span className="inline-flex items-center gap-1 rounded-md bg-accent-100 px-2 py-1 font-medium text-accent-800">
                <i className="ri-arrow-up-line" /> 上升中
              </span>
            </div>
          </div>
          <div className="mt-6 rounded-xl bg-secondary-100 p-4">
            <p className="text-sm leading-relaxed text-secondary-900">
              两个久未同框的实力影人官宣携手新片，选角与班底逐条曝光，本月大瓜焦点讨论持续升温，建议前往「焦点热议」围观。
            </p>
            <a
              href="#focus"
              className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-foreground-950 hover:text-primary-700"
            >
              去围观讨论 <i className="ri-arrow-right-line" />
            </a>
          </div>
        </aside>

        <ol className="flex flex-col gap-2.5 lg:col-span-2">
          {TREND_LIST.map((item) => {
            const isTop = item.rank <= 3;
            return (
              <li key={item.rank}>
                <a
                  href="#focus"
                  className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 px-4 py-3.5 transition hover:border-primary-300 hover:bg-background-100"
                >
                  <span
                    className={`font-display-latin w-8 shrink-0 text-center text-xl ${
                      isTop ? "text-primary-500" : "text-foreground-400"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <h4 className="font-heading truncate text-sm font-bold text-foreground-950 group-hover:text-primary-700 md:text-base">
                        {item.title}
                      </h4>
                      <span className={`shrink-0 rounded px-1.5 py-0.5 text-[10px] font-bold ${tagStyle(item.tag)}`}>
                        {item.tag}
                      </span>
                    </div>
                    <p className="mt-1 text-xs text-foreground-600">
                      {item.category} · 本月大瓜
                      <span className="hidden sm:inline"> · 点击进入焦点</span>
                    </p>
                  </div>
                  <div className="shrink-0 text-right">
                    <p className="text-sm font-bold text-primary-600">
                      <i className="ri-fire-fill mr-0.5 text-accent-500" />
                      {item.heat}
                    </p>
                    <p
                      className={`mt-0.5 inline-flex items-center gap-0.5 text-xs ${
                        item.delta > 0
                          ? "text-primary-700"
                          : item.delta < 0
                          ? "text-foreground-400"
                          : "text-secondary-700"
                      }`}
                    >
                      {item.delta > 0 ? (
                        <>
                          <i className="ri-arrow-up-line" /> 较前涨
                        </>
                      ) : item.delta < 0 ? (
                        <>
                          <i className="ri-arrow-down-line" /> 回落
                        </>
                      ) : (
                        <>持平</>
                      )}
                    </p>
                  </div>
                </a>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}